import Seo from "@/components/Seo";
import { Section, Container, Crumbs } from "@/components/kit";
import { Eyebrow } from "@/lib/anim";
import { SITE } from "@/lib/content";

export default function Privacy() {
  return (
    <>
      <Seo title="Privacy policy" canonical="/privacy-policy" description="How Prox collects, uses and protects your information." />
      <section className="pt-16 md:pt-24 pb-12 border-b border-[var(--stone)]" style={{ backgroundColor: "var(--bone)" }}>
        <Container size="md">
          <Crumbs items={[{ label: "Home", to: "/" }, { label: "Privacy policy" }]} />
          <Eyebrow>Legal</Eyebrow>
          <h1 className="t-display2">Privacy policy</h1>
          <p className="t-sm text-[var(--muted)] mt-4 font-mono">Last updated June 2026</p>
        </Container>
      </section>
      <Section bg="bone">
        <Container size="md" className="!px-0">
          <div className="prose">
            <p>Prox ("we", "us") respects your privacy and handles personal information in line with the Australian Privacy Principles under the Privacy Act 1988 (Cth). This policy explains what we collect and how we use it.</p>
            <h2>What we collect</h2>
            <ul>
              <li>Contact details you give us through the contact form, the fit call form, downloads and the calculator, such as your name, email, business name and website.</li>
              <li>The content of your enquiry, including the problem you describe and your budget range.</li>
              <li>Payment records when you buy an engagement. Card details are handled by Stripe and are never stored by Prox.</li>
              <li>Basic analytics about how the site is used, if analytics is enabled.</li>
            </ul>
            <h2>How we use it</h2>
            <ul>
              <li>To respond to your enquiry, run your engagement and send confirmations.</li>
              <li>To send occasional notes on cost, margin and sourcing, only if you opt in. You can unsubscribe at any time.</li>
              <li>To meet our legal and tax obligations.</li>
            </ul>
            <h2>Who we share it with</h2>
            <p>We use a small number of trusted processors to run the site and the business: Stripe for payments, Resend for email, Calendly for scheduling, and a website analytics provider. Each handles your data under its own terms. We do not sell your personal information.</p>
            <h2>Storage and security</h2>
            <p>We keep personal information only as long as needed for the purpose it was collected, or as required by law, and we take reasonable steps to protect it.</p>
            <h2>Your rights</h2>
            <p>You can ask to see, correct or delete the personal information we hold about you. Email <a href={`mailto:${SITE.email}`}>{SITE.email}</a> and we will respond within a reasonable time.</p>
            <h2>Contact</h2>
            <p>Prox, {SITE.location}. Email <a href={`mailto:${SITE.email}`}>{SITE.email}</a>.</p>
          </div>
        </Container>
      </Section>
    </>
  );
}
